import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getTeams as getTeamsFromMonolith, GetTeamsOptions, Team } from '~/monolith-api';

export type { GetTeamsOptions, Team };

const getTeamsSchema = z.object({
   limit: z.number().optional(),
   offset: z.number().optional(),
   order: z.enum(['ASC', 'DESC']).optional(),
   joinedSince: z.number().optional(),
   ownerTeamUserid: z.number().optional(),
   orderBy: z.enum(['teamid', 'name', 'reputation']).optional(),
});

export async function getTeams(options: GetTeamsOptions | undefined) {
   return await getTeamsFromMonolith(options);
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { limit, offset, order, joinedSince, ownerTeamUserid, orderBy } = getTeamsSchema.parse(
         req.body
      );
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getTeamsFromMonolith({
         limit,
         offset,
         order,
         joinedSince,
         ownerTeamUserid,
         orderBy,
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getTeamsFromClient = (options?: GetTeamsOptions): ReturnType<typeof getTeams> => {
   return bff()
      .post('/teams/getTeams', {
         ...options,
      })
      .then(response => response.data);
};
